<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>订单流程列表</h4>
        </div>
        <div class="mg20">
            <div class="main-bd">
                <el-tabs v-model="activeTab" @tab-click="handleClick">
                    <el-tab-pane  label="正式订单" name="formal"></el-tab-pane>
                    <el-tab-pane  label="试用订单" name="trial"></el-tab-pane>
                </el-tabs>
                <el-row class="addBtn" >
                    <div>
                        <el-button  style="float:left"  type="primary" size="small" @click="create">+添加新订单流程</el-button>
                        <el-form   :model="search_form" ref="form" :rules="rules">
                            <el-form-item label="流程描述" prop="search_name" :label-width="formLabelWidth">
                                <FlowSelect v-model="search_form.desc"
                                            @change="flowHandleChange" :activeTab="activeTab"  :isOrder="1" ></FlowSelect>
                                <el-button   type="primary" @click="getFlowService()">搜索</el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                </el-row>
                <el-table :data="list" style="width: 100%">
                    <!--<el-table-column prop="id" label="ID"></el-table-column>-->
                    <el-table-column prop="flows" label="" type="expand">
                        <template slot-scope="scope">
                            <div v-for="flow in scope.row.flows">
                                <span>{{flow['name']}}:</span>
                                <el-steps :active="9">
                                    <slot v-for="value in flow['nodes']">
                                        <el-step :title="value['executor_memo']"></el-step>
                                    </slot>
                                    <el-step title="完成"></el-step>
                                </el-steps>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="desc" label="流程描述"></el-table-column>
                    <el-table-column prop="action" label="动作">
                        <template slot-scope="scope">
                            <span v-for="action in actions">
                                <slot v-if="scope.row.action == action.value">
                                    {{action.label}}
                                </slot>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="branch_memo" label="部门"></el-table-column>
                    <el-table-column prop="user_memo" label="用户"></el-table-column>
                    <el-table-column prop="created_at" label="添加时间"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div>
                                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                                <el-button @click="handleDelete(scope.row.id)" type="text" size="small">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- Form -->
                <el-dialog title="流程设置" :visible.sync="dialogFormVisible" width="50%" center>
                    <el-form :model="form" :rules="rules" ref="form">
                        <el-form-item label="流程描述：" prop="desc" :label-width="formLabelWidth">
                            <el-col :span="8">
                                <el-input v-model="form.desc" auto-complete="off"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="Id" prop="id" hidden :label-width="formLabelWidth">
                            <el-input v-model="form.id" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="流程线：" prop="flows" :label-width="formLabelWidth">
                            <el-select
                                    v-model="form.flows"
                                    multiple
                                    style="margin-left: 20px;"
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in flows"
                                        :key=item.id
                                        :label="item.name"
                                        :value=item.id>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="动作：" prop="action" :label-width="formLabelWidth">
                            <el-select
                                    v-model="form.action"
                                    style="margin-left: 20px;"
                                    placeholder="请选择">
                                <el-option v-for="(item, key) in actions" :key="key" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="执行部门：" prop="branch_id" :label-width="formLabelWidth">
                            <el-cascader :change-on-select="true" :options="branches" :props="props"
                                         v-model="form.parent_path" @change="handleChange">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="执行人：" prop="user_id" :label-width="formLabelWidth">
                            <UserSelect :uid="form.user_id" @change="handleUser($event)"></UserSelect>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitForm" :loading="loading">确 定</el-button>
                    </div>
                </el-dialog>
                <el-row v-if="linkPage">
                    <pagination :linkPage="linkPage"></pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import FlowService from "~/services/flow";
    import {BranchService} from "~/services/Branch";
    import CommonService from "~/services/common";
    import NodeTable from "~/views/flow/node.vue";
    import UserSelect from "~/widgets/UserSelect.vue";
    import FlowSelect from "~/widgets/FlowSelect.vue";

    import {isNumber} from 'util';

    export default {
        components: {
            Pagination,
            FlowSelect,
            NodeTable,
            UserSelect
        },

        data() {
            return {
                props: {
                    label: 'name',
                    value: 'id',
                    children: 'childs'
                },
                linkPage: null,
                list: [], //订单流程列表
                flows: [], //所有流程
                actions: [//所有动作
                    {
                        value: 1,
                        label: '新增订单'
                    }, {
                        value: 2,
                        label: '关闭订单'
                    }, {
                        value: 3,
                        label: '修订订单'
                    }, {
                        value: 4,
                        label: '补充订单'
                    }],
                branches: [], //所有部门
                dialogFormVisible: false,
                form: {
                    id: '',
                    flows: [],
                    desc: '',
                    branch_id: 0,
                    order_type:0,
                    user_id: 0,
                    action: 0,
                    parent_path: []
                },
                formLabelWidth: '120px',
                rules: {
                    flows: [
                        {required: true, message: '请选择流程线', trigger: 'change'},
                    ],
                    action: [
                        {required: true, message: '请选择动作', trigger: 'change'},
                    ],
                    desc: [
                        {required: true, message: '请填写流程描述', trigger: 'change'},
                    ]
                },
                search_form:{
                    desc:''
                },
                activeTab: 'formal',
                loading: false,
            };
        },
        /**
         * 监听组件切换变化
         */
        watch: {
            $route(to, from) {
                let params = this.searcherModel;
                this.currentUseTab = this.activeTab;
                params['tab'] = this.activeTab;
                params['page'] = to.query["page"];
                params['perPage'] = to.query["perPage"];
            },

        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            this.initListData({
                page: to.query["page"],
                perPage: to.query["perPage"]
            });
        },
        mounted() {
            this.initListData();
        },
        methods: {
            flowHandleChange(object) {
                this.search_form.desc = object.value;
            },
            getFlowService(params = {}){

                let order_type = 0
                if(this.activeTab == 'trial') {
                    order_type = 1;
                }
                //加载订单流程列表
                FlowService.getOrderFlow({
                    page: params.page,
                    order_type:order_type,
                    perPage: params.perPage,
                    desc:this.search_form.desc,
                }).then(res => {
                    this.list = res.data
                    this.linkPage = res._meta;
                });
            },
            //删除操作
            handleDelete(id) {
                this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    FlowService.delOrder(id).then(res => {
                        let text = {
                            message: '删除成功',
                            type: 'success'
                        }
                        if (res.code) {
                            text.message = res.msg;
                            text.type = 'error';
                        }
                        this.$message(text);
                        this.flows = this.flows.filter(function (item) {
                            return item.id != id;
                        });
                        this.initListData();
                    })
                }).catch(() => {
                });
            },
            //表单提交
            submitForm() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (this.form.id) {
                            this.save();
                        } else {
                            this.addFlow();
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //添加产品弹窗
            create() {
                this.form = {
                    id: '',
                    flows: [],
                    desc: '',
                    branch_id: '',
                    user_id: '',
                    parent_path: []
                };
                this.dialogFormVisible = true
            },
            //添加新流程
            addFlow() {
                this.loading = true;
                let order_type = 0
                if(this.activeTab == 'trial') {
                    this.form.order_type = 1;
                }
                FlowService.createOrder(this.form).then(res => {
                    if (res.code == 0) {
                        this.flows.unshift(res.data);
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        this.initListData();
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            //编辑
            handleEdit(data) {
                this.form = Object.assign({}, data);
                this.$nextTick(function () {
                    if (data.branch_id) {
                        BranchService.getBranchInfo(data.branch_id).then(res => {
                            if (res.code == 0) {
                                this.form.parent_path = res.data.parent_path;
                                this.form.parent_path.push(data.branch_id.toString());
                            }
                            this.dialogFormVisible = true;
                        }).catch(err => {
                            console.error(err);
                        })
                    } else {
                        this.dialogFormVisible = true;
                    }
                })
                if (this.form.flows) {
                    this.form.flows = _.map(this.form.flows, 'id');
                }
                if (this.form.branch_id) {
                    this.form.branch_id = String(this.form.branch_id)
                }
            },
            //保存操作
            save() {
                this.loading = true;
                var data = Object.assign({}, this.form);
                delete data.created_at;
                var i = this.list.findIndex(function (item) {
                    return item.id == data.id;
                });
                FlowService.updateOrderFlow(data).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.list = [...this.list.slice(0, i), res.data, ...this.list.slice(i + 1)];
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            //默认加载
            initListData(params = {}) {
                let order_type = 0
                if(this.activeTab == 'trial') {
                    order_type = 1;
                }
                //加载订单流程列表
                FlowService.getOrderFlow({
                    page: params.page,
                    order_type:order_type,
                    perPage: params.perPage
                }).then(res => {
                    this.list = res.data
                    this.linkPage = res._meta;
                });
                //加载流程列表
                FlowService.getList({
                    no_page: 1,
                    order_type:order_type,
                    page: params.page,
                    perPage: params.perPage
                }).then(res => {
                    this.flows = res.data
                });
                //加载所有部门信息
                CommonService.getAllBranches({
                    page: params.page,
                    perPage: params.perPage
                }).then(res => {
                    this.branches = res.data;
                    this.linkPage = res._meta;
                });
            },

            handleUser($event) {
                if (!$event.value) {
                    this.form.user_id = '';
                } else {
                    this.form.user_id = $event.label;
                }
            },
            handleChange($event) {
                this.form.branch_id = _.last($event);
            },
            handleClick: function (tab, event) {
              this.activeTab = tab.name;
              this.search_form = {
                  desc: ''
              };
              this.loading = true;
              if(this.activeTab == 'trial') {
                  this.actions = [
                      {
                        value: 1,
                        label: '新增订单'
                      }
                  ];
              } else {
                  this.actions = [
                      {
                        value: 1,
                        label: '新增订单'
                      }, {
                        value: 2,
                        label: '关闭订单'
                      }, {
                        value: 3,
                        label: '修订订单'
                      }, {
                        value: 4,
                        label: '补充订单'
                      }
                  ];
              }
              let order_type = this.activeTab == 'trial' ? 1 : 0;
              // 使用 Promise.all 同时处理两个请求
              Promise.all([
                  FlowService.getOrderFlow({
                      desc: this.search_form.desc,
                      order_type: order_type,
                  }),
                  FlowService.getList({
                      no_page: 1,
                      order_type: order_type,
                  })
              ])
                  .then(([orderFlowRes, flowListRes]) => {
                      this.list = orderFlowRes.data;
                      this.linkPage = orderFlowRes._meta;
                      this.flows = flowListRes.data;
                      this.loading = false;
                  })
                  .catch(err => {
                      console.error('Tab switching error:', err);
                      this.loading = false;
                  });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/flow/order.vue